import React, { useEffect, useState } from "react";
import ItunesMonthly from "./upload/ItunesMonthly"
import Youtube from "./upload/Youtube"
import YoutubeRed from "./upload/YoutubeRed"
import GooglePlay from "./upload/GooglePlay"
import Amazon from "./upload/Amazon"
import Spotify from "./upload/Spotify"
import InternalProcess from "./upload/InternalProcess"
import Transactions from "./Transactions"
import Matching from "./Matching/Matching"
import korrectLogo from '../../assets/images/korrectLogoIcon.png';

export default function DataMGT(subEntity: any) {

    let [activeMenu, setActiveMenu] = useState("Transactions");
    const onChangeMenu = (e: any) => {
        console.log(e)
        setActiveMenu(e)
    }

    const closeModal = (e: any) => {
        const modal = document.getElementById("myModal") as HTMLElement;
        modal?.classList.remove("displayItem");
        modal?.classList.add("displayNoneItem");
        document.body.classList.remove("HiddenoverflowX");
    }

    const menu = [
        { label: 'Menu', value: 'Transactions' },
        { label: 'Menu', value: 'Matching' },
    ];

    const menu_sub = [
        { label: 'Menu', value: 'iTunes Monthly' },
        { label: 'Menu', value: 'Youtube' },
        { label: 'Menu', value: 'Youtube Red' },
        { label: 'Menu', value: 'Google Play' },
        { label: 'Menu', value: 'Amazon' },
        { label: 'Menu', value: 'Spotify' },
        { label: 'Menu', value: 'Internal Process' },
    ];


    return (
        <>
            {(subEntity) && <div id="myModal" className="modal pLarge ws-12 ">

                <a onClick={() => closeModal(true)} className="btn-xxs modalClose borderNone bgTransparent" style={{ position: "inherit" }} href="../../">
                    <i className="icon-close3 danger"></i>
                </a>

                <div className="allowHscroll allowVscroll full-height-vh95 ws-12 box" style={{ minHeight: "80%" }}>

                    <div className="ws-12" >

                        <div className="ws-2 pm borderReset full-height pLarge">
                            <div className="ws-12 text-center pLarge mtll mbl">
                                <img className="pull-none" src={korrectLogo} width={50} />
                            </div>

                            <ul className="main-menu pll prl ws-12">
                                <a className="full-width text-bold text-average text-m mtl ws-12 pbl">Transactions</a>
                                <ul >
                                    {menu?.map((value: any) => {
                                        return (<>
                                            {<li key={value.title} className={activeMenu === value.value ? " active" : ""}>
                                                <a className={"ws-12 text-sl text-normal"} onClick={() => { onChangeMenu(value.value) }}> {value.value}</a>
                                            </li>}
                                        </>)
                                    })}
                                </ul>

                            </ul>

                            <ul className="main-menu pll prl ws-12 mt pt">
                                <a className="full-width text-bold text-average text-m mtl ws-12 pbl">Reporting</a>
                                <ul >
                                    {menu_sub?.map((value: any) => {
                                        return (<>
                                            {<li key={value.title} className={activeMenu === value.value ? " active" : ""}>
                                                <a className={"ws-12 text-sl text-normal"} onClick={() => { onChangeMenu(value.value) }}> {value.value}</a>
                                            </li>}
                                        </>)
                                    })}
                                </ul>

                            </ul>

                        </div>

                        <div className="ws-10 pr pm landing">
                            {(activeMenu === 'iTunes Monthly') && <ItunesMonthly onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                            {(activeMenu === 'Youtube') && <Youtube onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                            {(activeMenu === 'Youtube Red') && <YoutubeRed onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                            {(activeMenu === 'Google Play') && <GooglePlay onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                            {(activeMenu === 'Amazon') && <Amazon onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                            {(activeMenu === 'Spotify') && <Spotify onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                            {(activeMenu === 'Internal Process') && <InternalProcess onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                            {(activeMenu === 'Transactions') && <Transactions onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                            {(activeMenu === 'Matching') && <Matching onChangeMenu={onChangeMenu} activeMenu={activeMenu} />}
                        </div>


                    </div>

                </div>
            </div>}
        </>
    );
}

